<template>
  <section>
    <div class="settings-header">
      {{ __('Domínios de E-mails e Landing Pages') }}
      <button
        class="btn btn-primary ml-auto"
        @click.prevent="add()"
      >
        {{ __('Adicionar domínio') }}
      </button>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="form-text">
          {{ __('Adicione domínios e verifique se a configuração de DNS dos seus domínios estão corretas.') }}
        </p>
        <div class="row">
          <div
            class="col-12"
            v-if="loading"
          >
            <i class="fa fa-circle-o-notch fa-spin mt-4" />
          </div>
          <div
            class="col-12"
            v-else
          >
            <ul
              class="domains settings-group list-group mt-4"
              v-if="domains.length"
            >
              <li
                class="list-group-item d-flex align-items-center"
                v-for="domain in domains"
                :key="domain.identifier"
              >
                <span>{{ domain.identifier }}
                  <span v-if="deleting && domain.id == domainId" class="bdk-text-red-600">({{ __('Excluindo') }}...)</span>
                </span><span class="ml-auto">
                  <button
                    class="btn btn-domain"
                    :class="{ 'btn-domain-danger': ! domain.verified || domain.disabled, 'btn-domain-success': domain.verified && ! domain.disabled }"
                    @click="verify(domain)"
                  ><span v-if="verifying === domain.identifier"><i class="fa fa-circle-o-notch fa-spin mr-1" /> {{ __('Verificando') }}...</span><span v-else><span v-if="domain.disabled">
                    <Component
                      class="mr-1"
                      :is="'IconTimes'"
                      color="#FFF"
                    /> {{ __('Domínio bloqueado') }}</span><span v-else-if="domain.verified">
                    <Component
                      class="mr-1"
                      :is="'IconCheck'"
                      color="#3B334A"
                    /> {{ __('DNS verificado') }}</span><span v-else>{{ __('Verificar DNS') }}</span></span></button><span v-if="domain.disabled === false">
                    <button
                      class="btn btn-domain ml-2"
                      @click="showRecords(domain)"
                    >
                      <u>{{ __('Exibir registros DNS') }}</u>
                    </button><a
                      class="ml-2"
                      href="#"
                      v-b-tooltip.left="__('Excluir domínio')"
                      @click="destroy(domain)"
                    >
                      <Component
                        :is="'IconTrash'"
                        :size="18"
                      /></a></span></span>
              </li>
            </ul>
            <div
              class="mt-4"
              v-else
            >
              <a
                href="#"
                @click.prevent="add()"
              >{{ __('Clique aqui para adicionar seu primeiro domínio.') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BModal
      id="modal-new-domain"
      ref="modal-new-domain"
      modal-class="modal-width-300"
      hide-footer="hide-footer"
    >
      <template slot="modal-header">
        <div class="modal-title">
          {{ __('Novo domínio') }}
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="close"
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <template slot="default">
        <form @submit="save">
          <div class="form-group">
            <label>{{ __('Domínio') }}</label>
            <input
              class="form-control"
              id="domain-name"
              type="text"
              v-model="domain"
              :placeholder="__('empresa.com.br')"
              pattern="^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?.)+[a-zA-Z]{2,13}$"
              required="required"
            >
          </div>
          <div class="d-flex flex-column modal-footer default-modal-footer p-0 mt-3">
            <button
              class="btn btn-primary"
              type="submit"
              :disabled="saving"
            >
              <span v-if="saving">{{ __('Salvando') }}...</span><span v-else>{{ __('Salvar') }}</span>
            </button>
            <button
              class="btn pb-0"
              type="button"
              :disabled="saving"
              @click.prevent="close"
            >
              <u class="btn-cancel">{{ __('Cancelar') }}</u>
            </button>
          </div>
        </form>
      </template>
    </BModal>
    <SettingsVerifyDomain />
  </section>
</template>

<script>
import { BModal, VBTooltip } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';

export default {
  components: {
    BModal,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  mounted () {
    this.loadDomains();

    Bus.$on('verifyingDomain', (domain) => this.verifying = domain);
    Bus.$on('domainUpdated', () => this.loadDomains());
  },

  data () {
    return {
      domain: '',
      domains: [],
      lastTried: null,
      loading: false,
      saving: false,
      deleting: false,
      domainId: '',
      verifying: null,
      configuration: {
        response: '',
      },
    };
  },

  methods: {
    loadDomains () {
      this.loading = true;

      this.$http.get('/settings/domain')
        .then((response) => {
          this.loading = false;
          this.domains = response.data;
        })
        .catch(() => Alert.error(this.__('Erro ao listar domínios, tente novamente mais tarde.')));
    },

    add () {
      this.$refs['modal-new-domain'].show();

      setTimeout(() => {
        document.querySelector('#domain-name').focus();
      }, 500);
    },

    showRecords (domain) {
      Bus.$emit('showDomainRecords', domain);
    },

    save (event) {
      event.preventDefault();

      this.saving = true;

      const domain = this.formatDomain(this.domain);

      this.$http.post('/settings/domain', { domain })
        .then(() => {
          Alert.success(this.__('Seu domínio está sendo adicionado. Notificaremos quando estiver pronto.'));

          this.domain = '';

          this.loadDomains();
        })
        .catch((response) => {
          if (response.status === 403 || response.status === 406) {
            return Alert.error(response.data.error);
          }

          Alert.error(this.__('Erro ao cadastrar domínio.'));
        })
        .finally(() => {
          this.saving = false;

          this.close();
        });
    },

    async destroy (domain) {
      if (! await Confirm(this.__('Deseja mesmo excluir este domínio?'))) {
        return;
      }

      this.domainId = domain.id;
      let timerId = null;

      timerId = setTimeout(() => {
        this.deleting = true;
      }, 200);

      this.$http.delete(`/settings/domain/${domain.id}`)
        .then(() => {
          clearTimeout(timerId);

          Alert.success(this.__('Domínio excluído.'));

          this.domains.splice(this.domains.indexOf(domain), 1);
        })
        .catch(error => {
          clearTimeout(timerId);
          Alert.error(error?.body?.message);
        }).finally(() => {
          this.deleting = false;
          this.domainId = '';
        });
    },

    verify (domain) {
      Bus.$emit('verifyDomain', domain);
    },

    formatDomain (domain) {
      domain = domain || '';
      const remove = ['http://', 'https://', 'www.', 'www1.'];

      for (const i in remove) {
        if (domain.indexOf(remove[i]) === 0) {
          domain = domain.replace(remove[i], '');
        }
      }

      return domain;
    },

    close () {
      this.$refs['modal-new-domain'].hide();
    },
  },
};
</script>

<style scoped>
.btn-cancel {
  font-size: 11px;
}
</style>
